export default __webpack_public_path__ + "static/media/template_normal.1a755f12.png";